import { IProductBrand } from '../DataStore/IProductBrand'

export const GET_PRODUCT_BRANDS_LOADING = 'GET_PRODUCT_BRANDS_LOADING'
export const GET_PRODUCT_BRANDS_SUCCESS = 'GET_PRODUCT_BRANDS_SUCCESS'
export const GET_PRODUCT_BRANDS_FAILURE = 'GET_PRODUCT_BRANDS_FAILURE'

interface GetProductBrandsLoading {
    type: typeof GET_PRODUCT_BRANDS_LOADING
}

interface GetProductBrandsSuccess {
    type: typeof GET_PRODUCT_BRANDS_SUCCESS
    payload: {
        brands: IProductBrand[]
    }
}

interface GetProductBrandsFailure {
    type: typeof GET_PRODUCT_BRANDS_FAILURE
    payload: {
        error: any
    }
}

export type ActionTypes =
    | GetProductBrandsSuccess
    | GetProductBrandsFailure
    | GetProductBrandsLoading
